<template>
    <div>
        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="panel panel-default">
                <div class="panel-body">
                    <table class="table table-condensed table-striped">
                        <thead>
                        <tr>
                            <th class="col-xs-1 text-center">
                                <input type="checkbox" :disabled="true">
                            </th>

                            <th class="col-xs-22">
                                Time
                            </th>

                            <th class="col-xs-1"></th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="login in logins.data">
                            <td class="text-center">
                                <input type="checkbox" :disabled="true">
                            </td>

                            <td>
                                {{ login.attributes.created_at | datetime }}
                            </td>

                            <td class="text-right">
                                <div class="btn-group list-actions">
                                    <button type="button" class="btn btn-sm" :disabled="true">
                                        <i class="fa fa-search"></i>
                                    </button>

                                    <button type="button" class="btn btn-sm" :disabled="true">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr v-if="!logins.data.length">
                            <td colspan="3" class="text-center">
                                <i>
                                    There are no logins to display.
                                </i>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="row">
                        <div class="col-xs-12 col-xs-offset-6">
                            <pager :pagination="logins.meta" @navigate="navigate"></pager>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import Pager from '@/components/Lists/Pager'

export default {
    components: {LoadingContainer, Pager},

    model: {
        prop: 'user',
        event: 'user-updated'
    },

    props: ['user'],

    data() {
        return {
            logins: null,

            loading: true,

            page: this.getQueryParam('page', 1)
        }
    },

    watch: {
        '$route'() {
            this.load()
        }
    },

    mounted() {
        this.load()
    },

    methods: {
        load() {
            http.get('/api/v2/logins', {
                page: this.page,
                page_size: 25,
                'filter[user_id]': this.user.id
            }).then(response => {
                this.logins = response.data

                this.loading = false
            })
        },

        navigate(page) {
            this.page = page

            if (this.page === parseInt(this.$route.query.page)) {
                this.load()
            }

            this.$router.push('logins?page=' + this.page)
        },

        getQueryParam(key, defaultValue = null) {
            return typeof this.$route.query[key] !== 'undefined' ? this.$route.query[key] : defaultValue
        }
    }
}
</script>
